import React, { useContext, useState } from 'react';
import { CircularProgress, Snackbar, Alert } from '@mui/material';
import { getAuth, signInWithPopup, onAuthStateChanged, GoogleAuthProvider } from 'firebase/auth';

import Form from '../../components/Form/Form';

import GamesContext from '../../store/games-context';
import UserContext from '../../store/user-context';
import { handleSubmit } from '../../utils/form.utils';
import styles from './addrun.module.scss';

const AddRun = () => {
  const gamesContext = useContext(GamesContext);
  const userContext = useContext(UserContext);
  const [addConfirmation, updateAddConfirmation] = useState<boolean>(false);
  const [addError, updateAddError] = useState<boolean>(false);
  const games = gamesContext.games;

  const auth = getAuth(userContext.firebaseApp);
  const provider = new GoogleAuthProvider();
  onAuthStateChanged(auth, (user) => {
    if(!!userContext && !!userContext.setUser){
      if(user) {
        userContext.setUser(user);
      }
    }
  });

  if (games && games.length > 0) {
    if(userContext.user && userContext.user.isAnonymous === false) {
      return (
        <div className={styles.container}>
        <h2>Add Run</h2>
        <Form
          handleSubmit={handleSubmit}
          onSuccess={() => updateAddConfirmation(true)}
          onError={() => updateAddError(true)}
        />
        <Snackbar open={addConfirmation} autoHideDuration={6000} onClose={() => updateAddConfirmation(false)}>
          <Alert onClose={() => updateAddConfirmation(false)} severity="success" sx={{ width: '100%' }}>
            Run Added succesfully!
          </Alert>
        </Snackbar>
        <Snackbar open={addError} autoHideDuration={6000} onClose={() => updateAddError(false)}>
          <Alert onClose={() => updateAddError(false)} severity="error" sx={{ width: '100%' }}>
          Unable to add, please try again later
          </Alert>
        </Snackbar>
        </div>
      )
    }
  } else {
    return (<div className={styles.userheader}><span>Only allowed users can add new runs</span><button onClick={()=> signInWithPopup(auth, provider)}>Login</button></div>);
  }
  return (
    <div className={styles.loaderContainer}>
      <CircularProgress className={styles.loader} />
    </div>
  );
}

export default AddRun;
